import { render, staticRenderFns } from "./BalanceChanges.vue?vue&type=template&id=ff567ba6&scoped=true&"
import script from "./BalanceChanges.vue?vue&type=script&lang=js&"
export * from "./BalanceChanges.vue?vue&type=script&lang=js&"
import style0 from "./BalanceChanges.vue?vue&type=style&index=0&id=ff567ba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff567ba6",
  null
  
)

export default component.exports